module.exports = __webpack_public_path__ + "static/media/furvac360-5.4916de51.jpg";